export const posthogActionNames = {
  sidebar: {
    COMPANY_ITEM: 'company_item',
    SWITCH_COMPANY: 'switch_company',
    LOG_OUT: 'clicked_log_out',
    QRED_VISA: 'qred_visa',
    SELL_YOUR_INVOICES: 'sell_your_invoices',
    BECOME_A_TESTER: 'become_a_tester',
    CHANGE_LANGUAGE: 'language_menu',
  },
  dashboard: {
    STEPPER_LOAN_OFFER_EXPIRED: 'offer_expired',
    STEPPER_LOAN_DECISION: 'decision',
    STEPPER_PAY_OUT: 'pay_out',
    STEPPER_REVIEW: 'review',
    STEPPER_OFFER: 'offer',
    STEPPER_CONFIRMATION: 'confirmation',
    STEPPER_UPLOAD_DOCUMENTS: 'upload_documents',
    STEPPER_UPLOAD_DOCUMENTS_BUTTON_CLICKED: 'upload_documents_button_clicked',
    STEPPER_UPLOAD_DOCUMENTS_MODAL: 'upload_documents_modal_opened',
    STEPPER_UPLOAD_DOCUMENTS_MODAL_CLOSED: 'upload_documents_modal_closed',
    STEPPER_UPLOAD_DOCUMENTS_MODAL_SUBMIT: 'upload_documents_modal_submit',
    APPLY_FOR_LOAN: 'apply_now',
    APPLY_FOR_LOAN_INCREASE: 'apply_loan_increase',
    DOWNLOAD_INVOICE: 'download_invoice',
    DOWNLOAD_DOCUMENTS: 'download_documents',
    PREVIOUS_LOAN_DOWNLOAD_INVOICE: 'previous_loan_download_invoice',
    PREVIOUS_LOAN_DOWNLOAD_ALL_INVOICES: 'previous_loan_download_all_invoices',
    FINAL_INVOICE: 'final_invoice',
    PAID_INVOICE: 'paid_invoices',
    UPCOMING_INVOICES: 'upcoming_invoices',
    QRED_VISA: 'qred_visa',
  },
  profile: {
    SAVE_PROFILE: 'save',
    EDIT_PROFILE: 'edit',
    CANCEL_PROFILE: 'cancel',
    UPDATE_PHONE_NUMBER: 'updates_PhoneNumber',
    UPDATE_EMAIL: 'updates_Email',
  },
  faq: {
    CATEGORY_CLICKED: 'category_clicked',
    QUESTION_CLICKED: 'question_clicked',
  },
  document: {
    DOWNLOAD: 'download',
  },
};
